// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconHome } from '@tabler/icons';

const icons = {
    IconHome
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
    id: 'dashboard',
    title: <FormattedMessage id="dashboard" />,
    icon: icons.IconHome,
    type: 'group',
    url: 'dashboard',
    roles: ['employee', 'employer']
};

export default dashboard;
